(() => {
  const pad = (value) => String(value).padStart(2, '0');

  const initTimer = (root) => {
    const timer = root.querySelector('[data-lp-mg-timer]');
    if (!timer) return;

    const hours = timer.querySelector('[data-lp-mg-hours]');
    const minutes = timer.querySelector('[data-lp-mg-minutes]');
    const seconds = timer.querySelector('[data-lp-mg-seconds]');

    const tick = () => {
      const now = new Date();
      const end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      const remaining = Math.max(0, Math.floor((end - now) / 1000));

      hours.textContent = pad(Math.floor(remaining / 3600));
      minutes.textContent = pad(Math.floor((remaining % 3600) / 60));
      seconds.textContent = pad(remaining % 60);
    };

    tick();
    window.setInterval(tick, 1000);
  };

  const initCarousel = (root) => {
    const carousel = root.querySelector('[data-lp-mg-carousel]');
    const track = carousel?.querySelector('[data-lp-mg-track]');
    if (!carousel || !track) return;

    const originals = Array.from(track.querySelectorAll('[data-lp-mg-slide]'));
    const count = originals.length;
    if (!count) return;

    const cloneCount = Math.min(3, count);
    originals.slice(0, cloneCount).forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.removeAttribute('data-lp-mg-slide');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
    originals.slice(-cloneCount).reverse().forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.removeAttribute('data-lp-mg-slide');
      clone.setAttribute('aria-hidden', 'true');
      track.insertBefore(clone, track.firstChild);
    });

    const dotsContainer = carousel.querySelector('[data-lp-mg-dots]');
    const labelTemplate = dotsContainer?.dataset.slideLabel || '';
    const dots = originals.map((_, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'lp-mg__carousel-dot';
      button.setAttribute('aria-label', labelTemplate.replace('[index]', String(index + 1)));
      button.addEventListener('click', () => moveTo(index));
      dotsContainer?.appendChild(button);
      return button;
    });

    let index = 0;
    let moving = false;
    let touchStart = null;

    const step = () => {
      const firstSlide = track.firstElementChild;
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      return firstSlide.getBoundingClientRect().width + gap;
    };

    const paint = (withoutAnimation = false) => {
      if (withoutAnimation) track.style.transition = 'none';
      track.style.transform = `translate3d(${-(index + cloneCount) * step()}px, 0, 0)`;
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === ((index % count) + count) % count);
      });
      if (withoutAnimation) {
        void track.offsetWidth;
        track.style.transition = '';
      }
    };

    const moveTo = (nextIndex) => {
      if (moving) return;
      moving = true;
      index = nextIndex;
      paint();
    };

    track.addEventListener('transitionend', () => {
      moving = false;
      if (index >= count || index < 0) {
        index = ((index % count) + count) % count;
        paint(true);
      }
    });

    carousel.querySelector('[data-lp-mg-prev]')?.addEventListener('click', () => moveTo(index - 1));
    carousel.querySelector('[data-lp-mg-next]')?.addEventListener('click', () => moveTo(index + 1));

    track.addEventListener(
      'touchstart',
      (event) => {
        touchStart = event.touches[0].clientX;
      },
      { passive: true }
    );
    track.addEventListener(
      'touchend',
      (event) => {
        if (touchStart === null) return;
        const distance = event.changedTouches[0].clientX - touchStart;
        if (Math.abs(distance) > 40) moveTo(index + (distance < 0 ? 1 : -1));
        touchStart = null;
      },
      { passive: true }
    );

    window.addEventListener('resize', () => paint(true));
    paint(true);
  };

  const initSticky = (root) => {
    const sticky = root.querySelector('[data-lp-mg-sticky]');
    const trigger = root.querySelector('[data-lp-mg-sticky-trigger]');
    if (!sticky || !trigger) return;

    const update = () => {
      sticky.classList.toggle('is-visible', trigger.getBoundingClientRect().top < window.innerHeight * 0.5);
    };

    window.addEventListener('scroll', update, { passive: true });
    update();
  };

  const init = (root) => {
    if (root.dataset.lpMgReady === 'true') return;
    root.dataset.lpMgReady = 'true';
    initTimer(root);
    initCarousel(root);
    initSticky(root);
  };

  document.querySelectorAll('[data-lp-mg]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-lp-mg]');
    if (root) init(root);
  });
})();
